import { repository } from 'src/jtech/jtech-repository'
export const AnalyzeInvoiceSettlementRepository = {

  INTERFACE_NAMES: {
    LOAD_INVOICE_SETTLEMENT: 'analyzeInvoiceSettlement.pesquisar',
    DETAIL_EXEMPT_ORDER: 'analyzeInvoiceSettlement.detalhar',
    APPROVE_EXEMPTION: 'analyzeInvoiceSettlement.approval',
    DENY_EXEMPTION: 'analyzeInvoiceSettlement.disapprove',
    ALTER_EXEMPTION: 'analyzeInvoiceSettlement.alterar',
    FORM_FILTER: 'analyzeInvoiceSettlement.pesquisar',
    HISTORY: 'analyzeInvoiceSettlement.obterTodoHistorico',
    EXEMPTION_METRICS: 'analyzeInvoiceSettlement.exemptionMetrics',
    SEARCH_WITH_FILTERS: 'analyzeInvoiceSettlement.pesquisar'
  },

  async load () {
    return await repository.resolve(this.INTERFACE_NAMES.LOAD_INVOICE_SETTLEMENT)
  },

  async loadInvoiceSettlementHistory () {
    return await repository.resolve(this.INTERFACE_NAMES.LOAD_INVOICE_SETTLEMENT)
  },

  async loadInvoiceSettlementHistoryDatatableModel () {
    const { registros: records } = await repository.resolveDatatableModel(
      this.INTERFACE_NAMES.LOAD_INVOICE_SETTLEMENT
    )
    return records || []
  },

  async loadDatatableModel (params) {
    const { registros: records } = await repository.resolveDatatableModel(
      this.INTERFACE_NAMES.LOAD_INVOICE_SETTLEMENT,
      { ...params }
    )
    return records
  },

  async loadInvoiceSettlementHistoryDatatable () {
    const { registros: forms } = await repository.resolveDatatable(
      this.INTERFACE_NAMES.HISTORY
    )
    return forms || []
  },

  async loadDatatable () {
    return await repository.resolveDatatable(
      this.INTERFACE_NAMES.LOAD_INVOICE_SETTLEMENT
    )
  },

  async loadDetail (id) {
    return await repository.resolve(
      this.INTERFACE_NAMES.DETAIL_EXEMPT_ORDER,
      { id: id }
    )
  },

  formFilter: async function () {
    const form = await repository.resolve(this.INTERFACE_NAMES.FORM_FILTER)
    return form
  },

  async backToMain () {
    return await repository.resolve(this.INTERFACE_NAMES.LOAD_INVOICE_SETTLEMENT)
  },

  async approve (params) {
    return await repository.resolveLogic(this.INTERFACE_NAMES.APPROVE_EXEMPTION, {
      id: params
    })
  },

  async deny (params) {
    return await repository.resolveLogic(this.INTERFACE_NAMES.DENY_EXEMPTION, {
      id: params.id,
      observation: params.observation
    })
  },

  async loadExemptionMetrics () {
    const { registros } = await repository.resolveDatatableModel(
      'analyzeInvoiceSettlement.hql',
      {
        grid: 'exemptionGrid'
      }
    )
    return registros
  },

  searchWithFilters: async function (params = {}) {
    const { registros: records } = await repository.resolveDatatableModel(
      this.INTERFACE_NAMES.SEARCH_WITH_FILTERS,
      {
        concessionContractIds: params.concessionContract,
        invoiceSettlementStatus: params.invoiceSettlementStatus,
        attendant: params.attendant,
        approver: params.approver,
        consumerUnitId: params.consumerUnitId,
        personDocument: params.personDocument
      }
    )
    return records || []
  }

}
